// modules
import { handleActions } from 'redux-actions'

// constants
import { PATHWAY_TAB_LIST } from 'src/constants'

// actions
import {
  setPathwayList,
  setPathwayAssignedList,
  setPathwayQuestionListModal,
  setPathwayQuestionListFilter,
  setPathwayPatientList,
  setPathwayPatientValues,
  setPathwayActiveTab,
  setPatientAnswerList,
  setPathwayPredefinedFilter,
  resetPathway
} from 'src/store/modules/patient/pathways'
import { deletePatientData } from 'src/store/modules/actionCreators'

const initialState = {
  pathwayList: [],
  pathwayAssignedList: [],
  pathwayQuestionListModal: [],
  pathwayQuestionListFilter: [],
  pathwayPatientList: [],
  pathwayPatientValues: {},
  pathwayActiveTab: PATHWAY_TAB_LIST[0],
  patientAnswerList: [],
  pathwayPredefinedFilter: {}
}

export default handleActions(
  {
    [setPathwayList](state, { payload: pathwayList }) {
      return {
        ...state,
        pathwayList
      }
    },

    [setPathwayAssignedList](state, { payload: pathwayAssignedList }) {
      return {
        ...state,
        pathwayAssignedList
      }
    },

    [setPathwayQuestionListModal](
      state,
      { payload: pathwayQuestionListModal }
    ) {
      return {
        ...state,
        pathwayQuestionListModal
      }
    },

    [setPathwayQuestionListFilter](
      state,
      { payload: pathwayQuestionListFilter }
    ) {
      return {
        ...state,
        pathwayQuestionListFilter
      }
    },

    [setPathwayPatientList](state, { payload: pathwayPatientList }) {
      return {
        ...state,
        pathwayPatientList
      }
    },

    [setPathwayPatientValues](state, { payload: pathwayPatientValues }) {
      return {
        ...state,
        pathwayPatientValues
      }
    },

    [setPathwayActiveTab](state, { payload: pathwayActiveTab }) {
      return {
        ...state,
        pathwayActiveTab
      }
    },

    [setPatientAnswerList](state, { payload: patientAnswerList }) {
      return {
        ...state,
        patientAnswerList
      }
    },

    [setPathwayPredefinedFilter](state, { payload: pathwayPredefinedFilter }) {
      return {
        ...state,
        pathwayPredefinedFilter
      }
    },

    [resetPathway]() {
      return initialState
    },

    [deletePatientData]() {
      return initialState
    }
  },
  initialState
)
